import ContactBlock from './ContactBlock';
import ContactForm from './ContactForm';
import ContentBlock from './ContentBlock';
import Footer from './Footer';
import Header from './Header';
import HeroBlock from './HeroBlock';
import PortfolioBlock from './PortfolioBlock';
import PostsBlock from './PostsBlock';
import ServicesBlock from './ServicesBlock';
import Social from './Social';
import TestimonialsBlock from './TestimonialsBlock';
import Layout from './Layout';

export {
    ContactBlock,
    ContactForm,
    ContentBlock,
    Footer,
    Header,
    HeroBlock,
    PortfolioBlock,
    PostsBlock,
    ServicesBlock,
    Social,
    TestimonialsBlock,
    Layout
};

export default {
    ContactBlock,
    ContactForm,
    ContentBlock,
    Footer,
    Header,
    HeroBlock,
    PortfolioBlock,
    PostsBlock,
    ServicesBlock,
    Social,
    TestimonialsBlock,
    Layout
};
